module.exports = __webpack_public_path__ + "static/media/infographic-upsight.17e6a63d.png";